import { csx } from '@vtex/admin-ui'

const content = {
  padding: '$space-2',
}

const styles = {
  item: csx({
    '[data-variant="neutralTertiary"][data-open="false"]': content,
    '[data-variant="neutralTertiary"][data-open="true"]': content,
    'svg:not(span > svg)': {
      display: 'none',
    },
    span: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      gap: '$space-2',
      whiteSpace: 'nowrap',
      width: '100%',
      '> :last-child': {
        marginLeft: 'auto',
      },
      svg: {
        margin: '0',
      },
    },
  }),
  nestedMenu: csx({
    whiteSpace: 'nowrap',
  }),
}

export default styles
